import { render, staticRenderFns } from "./FormInBranch.vue?vue&type=template&id=f20f7bb6&scoped=true&"
import script from "./FormInBranch.vue?vue&type=script&lang=js&"
export * from "./FormInBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormInBranch.vue?vue&type=style&index=0&id=f20f7bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20f7bb6",
  null
  
)

export default component.exports